<template>
  <div class="user-list">
    <h2>用户列表</h2>
    <br />
    <div>
      id / openid / 昵称:
      <input v-model="searchQuery" style="width: 300px" type="text" /> &nbsp;
      <button @click="searchUser">搜索</button>
    </div>
    <br />
    <br />

    <!-- 优化后的表格 -->
    <div class="table-wrapper">
      <table v-if="users.length" class="user-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>昵称</th>
            <th>OpenID</th>
            <th>小爱心</th>
            <th>登录时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td data-label="ID">{{ user.id }}</td>
            <td data-label="昵称">{{ user.nickname }}</td>
            <td data-label="OpenID" class="openid-cell">{{ user.openid }}</td>
            <td data-label="小爱心">{{ user.balance }}</td>
            <td data-label="登录时间">{{ formatTime(user.last_login_time) }}</td>
            <td data-label="操作">
              <button class="detail-btn" @click="showUserDetails(user)">详情</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 用户详情弹框 -->
    <div v-if="selectedUser" @click.self="closeModal" class="modal-overlay">
      <div class="modal">
        <h3>用户详情</h3>
        <br />
        <div class="table-scroll-wrapper">
        <table width="90%"  class="user-detail-table">
          <tr>
            <td>id:</td>
            <td>
              {{ selectedUser.id }}
            </td>
            <td rowspan="2">
              <img width="180" :src="selectedUser.homepage_bg" alt="" />
            </td>
          </tr>
          <tr>
            <td>昵称:</td>
            <td>
              {{ selectedUser.nickname }}
            </td>
          </tr>
          <tr>
            <td>openid:</td>
            <td>
              {{ selectedUser.openid }}
            </td>
            <td rowspan="2">
              <img width="100" :src="selectedUser.avatar_url" alt="" />
            </td>
          </tr>
          <tr>
            <td>小爱心:</td>
            <td>
              {{ selectedUser.balance }}
            </td>
          </tr>
          <tr>
            <td>签到连续天数:</td>
            <td>{{ selectedUser.signStreak }}</td>
            <td>登录时间:{{ formatTime(selectedUser.last_login_time) }}</td>
          </tr>
          <tr>
            <td>签到时间:</td>
            <td>{{ selectedUser.lastSignin }}</td>
          </tr>
        </table>
        </div>
        <hr />
        <br />
        <div style="display: flex; align-items: center;justify-content: space-between; gap: 50px; flex-wrap: wrap;">
          <div style="color: red">
            + <input v-model="balance" style="width: 90px" type="text" />❤
            <button @click="addBalance" style="background-color: #428bca">
              确定
            </button>
            <p style="padding-left: 20px;" v-html="msg"></p>
          </div>
          <div style="background-color: #ccc; padding: 10px; border-radius: 8px;">
            发送通知类型：
            <select @change="handleSelectChange" v-model="selectedValue">
              <option value="奖励通知">奖励通知</option>
              <option value="补偿通知">补偿通知</option>
              <option value="感谢通知">感谢通知</option>
              <option value="系统通知">系统通知</option>
            </select>
            &nbsp; <button style="background-color: #428bca" @click="usercon">确定发送</button>
            <br><br>
            <textarea cols="35" rows="6" name="" v-model="Content" placeholder="请输入通知内容" id=""></textarea>
            &nbsp;
          </div>
        </div>
        <br />
        <div style="display: flex; gap: 10px; justify-content: flex-end;">
          <button class="close-btn" @click="closeModal">关闭</button>
          <button class="delete-user-btn" @click="showDeleteConfirm(selectedUser)">注销用户</button>
        </div>
      </div>
    </div>

    <!-- 注销确认对话框 -->
    <div v-if="showDeleteModal" @click.self="closeDeleteModal" class="modal-overlay">
      <div class="modal delete-modal">
        <h3 style="color: #f56c6c;">⚠️ 确认注销用户</h3>
        <br />
        <div class="delete-info">
          <p><strong>用户信息：</strong></p>
          <p>ID：{{ currentDeleteUser?.id }}</p>
          <p>昵称：{{ currentDeleteUser?.nickname || '未设置' }}</p>
          <p>OpenID：{{ currentDeleteUser?.openid }}</p>
          <p>小爱心余额：{{ currentDeleteUser?.balance }}</p>
        </div>
        
       <div class="data-stats" v-if="userStats">
  <p><strong>📊 将删除以下数据：</strong></p>
  <ul>
    <li>🍽️ 菜品：{{ userStats.dishesCount || 0 }} 个</li>
    <li>📦 我的订单：{{ userStats.myOrdersCount || 0 }} 个</li>
    <li>🏪 店铺订单：{{ userStats.storeOrdersCount || 0 }} 个</li>
    <li>💳 爱心流水：{{ userStats.billsCount || 0 }} 条</li>
    <li>📅 打卡：{{ userStats.checkinsCount || 0 }} 次</li>
    <li>📂 分类：{{ userStats.categoriesCount || 0 }} 个</li>
  </ul>
</div>
        
        <div class="warning-box">
          <p class="warning-text">⚠️ 此操作不可恢复，所有数据将被永久删除！</p>
          <label>
            请输入 <strong>"确认注销"</strong> 以继续：
            <input 
              v-model="confirmText" 
              type="text" 
              placeholder="输入 确认注销"
              class="confirm-input-field"
              @keyup.enter="confirmDelete"
            />
          </label>
        </div>
        
        <div style="display: flex; gap: 10px; justify-content: center; margin-top: 20px;">
          <button class="btn-cancel" @click="closeDeleteModal">取消</button>
          <button 
            class="btn-confirm-delete" 
            @click="confirmDelete"
            :disabled="confirmText !== '确认注销' || deleting"
          >
            {{ deleting ? '注销中...' : '确认注销' }}
          </button>
        </div>
      </div>
    </div>

    <div class="pagination">
      <button @click="prevPage" :disabled="page <= 1">上一页</button>
      <span>第 {{ page }} 页 / 共 {{ totalPages }} 页</span>
      <button @click="nextPage" :disabled="page >= totalPages">下一页</button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { getUserDataStats, deleteUserAccount } from "@/api/houtai";
export default {
  name: "UserList",
  data() {
    return {
      users: [],
      page: 1,
      pageSize: 50,
      total: 0,
      tableHeaders: [],
      selectedUser: null,
      searchQuery: "",
      balance: null,
      msg: '',
      selectedValue: '奖励通知',
      Content: '',
      // 注销相关
      showDeleteModal: false,
      currentDeleteUser: null,
      userStats: null,
      confirmText: '',
      deleting: false
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
  },
  methods: {
    formatTime(time) {
      if (!time) {
        return "";
      }
      const options = {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Asia/Shanghai",
      };
      return new Intl.DateTimeFormat("zh-CN", options).format(new Date(time));
    },
    showUserDetails(user) {
      this.selectedUser = user;
    },
    closeModal() {
      this.msg = ''
      this.selectedUser = null;
    },
    async fetchUsers() {
      const res = await request.get(`/houtai/allUsers`, {
        params: {
          page: this.page,
        },
      });
      if (res.status === 200) {
        this.users = res.result;
        this.total = res.total;
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchUsers();
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.fetchUsers();
      }
    },
  async searchUser() {
  if (!this.searchQuery.trim()) {
    alert("请输入 id、openid 或昵称");
    return;
  }
  
  const keyword = this.searchQuery.trim();
  
  try {
    // 先尝试按 id 或 openid 搜索
    const res1 = await request.get(`/houtai/getUser`, {
      params: {
        idOrOpenid: keyword,
      },
    });
    
    if (res1.status === 200 && res1.result && res1.result.length > 0) {
      // 找到结果，直接显示
      if (res1.result.length === 1) {
        this.selectedUser = res1.result[0];
      } else {
        this.users = res1.result;
        this.selectedUser = null;
        alert(`找到 ${res1.result.length} 个匹配的用户`);
      }
      return;
    }
  } catch (error) {
    // idOrOpenid 没找到，继续尝试按昵称搜索
    console.log("按 ID/OpenID 未找到，尝试按昵称搜索");
  }
  
  try {
    // 按昵称模糊搜索
    const res2 = await request.get(`/houtai/getUser`, {
      params: {
        nickname: keyword,
      },
    });
    
    if (res2.status === 200 && res2.result && res2.result.length > 0) {
      if (res2.result.length === 1) {
        this.selectedUser = res2.result[0];
      } else {
        this.users = res2.result;
        this.selectedUser = null;
        alert(`找到 ${res2.result.length} 个匹配的用户（按昵称）`);
      }
    } else {
      alert("未找到匹配的用户");
      this.selectedUser = null;
    }
  } catch (error) {
    console.error("搜索失败:", error);
    alert("搜索失败，请稍后重试");
  }
},
    async addBalance() {
      if (!this.balance) {
        alert("请输入 小爱心数量");
        return;
      }
      const res = await request.post(`/houtai/addBalance`, {
        idOrOpenid: this.selectedUser.id,
        value: this.balance
      });
      console.log(res);
      if (res.status === 200) {
        this.selectedUser.balance = res.newBalance
        this.Content = `感谢您积极参与并完成了对我的美食记小程序的评价！您的${this.balance}颗小爱心已到账。`
        this.msg = res.msg
      }
    },
    handleSelectChange() {
      if (this.selectedValue === '奖励通知') {
        this.Content = `感谢您积极参与并完成了对我的美食记小程序的评价！您的${this.balance}颗小爱心已到账。`
      }
      if (this.selectedValue === '补偿通知') {
        this.Content = `非常抱歉给您带来不好的体验，我们特此补偿您${this.balance}颗小爱心`
      }
      if (this.selectedValue === '感谢通知') {
        this.Content = `非常感谢您的支持与认可，我们特此奖励您${this.balance}颗小爱心`
      }
      if (this.selectedValue === '系统通知') {
        this.Content = ''
      }
    },
    async usercon() {
      const res = await request.post(`/houtai/addtongzhi`, {
        openid: this.selectedUser.openid,
        title: this.selectedValue,
        content: this.Content
      });
      if (res.code === 0)
        this.Content = ''
      alert(res.msg)
    },
    
    // ========== 注销功能 ==========
    // 显示注销确认对话框
    async showDeleteConfirm(user) {
      this.currentDeleteUser = user
      this.confirmText = ''
      this.userStats = null
      this.showDeleteModal = true
      
      // 获取用户数据统计
      try {
        const res = await getUserDataStats({
          openid: user.openid
        })

        console.log('用户统计数据:', res.data)
          this.userStats = res.data
      } catch (error) {
        console.error('获取用户统计失败:', error)
      }
    },
    
    // 确认删除用户
    async confirmDelete() {
      if (this.confirmText !== '确认注销') {
        alert('请输入"确认注销"')
        return
      }
      
      this.deleting = true
      
      try {
        const res = await deleteUserAccount({
          openid: this.currentDeleteUser.openid,
          confirm: '确认注销'
        })
        console.log('注销结果:', res.msg)
        if (res.code === 0) {
          alert('用户注销成功，所有数据已清除')
          this.closeDeleteModal()
          // 关闭详情弹框
          this.closeModal()
          // 刷新列表
          this.fetchUsers()
        } else {
          alert(res.data?.msg || '注销失败')
        }
      } catch (error) {
        console.error('注销失败:', error)
        alert('网络错误，请稍后重试')
      } finally {
        this.deleting = false
      }
    },
    
    // 关闭注销对话框
    closeDeleteModal() {
      this.showDeleteModal = false
      this.currentDeleteUser = null
      this.userStats = null
      this.confirmText = ''
      this.deleting = false
    }
  },
  mounted() {
    this.fetchUsers();
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.user-list {
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  max-width: 1400px;
  margin: 0 auto;
}

h2 {
  color: #333;
  font-size: 24px;
  margin-bottom: 20px;
}

/* 表格容器 - 支持横向滚动 */
.table-wrapper {
  overflow-x: auto;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

/* 表格样式优化 */
.user-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 14px;
}

.user-table thead tr {
  background: linear-gradient(135deg, #b8c5fe 0%, #ba97de 100%);
}

.user-table th {
  padding: 14px 16px;
  font-weight: 600;
  color: white;
  font-size: 14px;
  letter-spacing: 0.5px;
  text-align: center;
}

.user-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
  color: #555;
}

.user-table tbody tr {
  transition: all 0.3s ease;
}

.user-table tbody tr:hover {
  background-color: #f8f9ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* OpenID 列样式 */
.openid-cell {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #666;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 详情按钮样式 */
.detail-btn {
  background: linear-gradient(135deg, #c1caf7 0%, #d4baef 100%);
  color: #ffffff;
  border: none;
  padding: 6px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
}

.detail-btn:hover {
  transform: translateY(-2px);
}

/* 分页样式 */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 30px;
  flex-wrap: wrap;
}

.pagination button {
  padding: 8px 16px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #667eea;
  font-weight: 500;
}

.pagination button:hover:not(:disabled) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: transparent;
  transform: translateY(-1px);
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination span {
  color: #666;
  font-size: 14px;
}

/* 弹框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 800px;
  display: block;
  margin: 0 auto;
  max-height: 96vh;
  margin-top: 20px;
  overflow-y: auto;
}

.delete-modal {
  width: 500px;
}

.modal table tr td:first-child {
  font-weight: bold;
  text-align: right;
  padding-right: 10px;
  height: 50px;
  width: 120px;
}

/* 按钮样式 */
.close-btn {
  background-color: #909399;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 10px;
}

.close-btn:hover {
  background-color: #a6a9ad;
}

.delete-user-btn {
  background-color: #f56c6c;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 10px;
}

.delete-user-btn:hover {
  background-color: #f78989;
}

/* 注销对话框样式 */
.delete-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.delete-info p {
  margin: 5px 0;
  font-size: 14px;
}

.data-stats {
  background-color: #fef0f0;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.data-stats ul {
  margin: 10px 0 0;
  padding-left: 20px;
}

.data-stats li {
  margin: 5px 0;
  color: #666;
  margin-right: 20px;
  font-size: 14px;
}

.warning-box {
  margin-bottom: 20px;
}

.warning-text {
  color: #f56c6c;
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 14px;
}

.confirm-input-field {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 8px;
  box-sizing: border-box;
}

.btn-cancel {
  background-color: #909399;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-cancel:hover {
  background-color: #a6a9ad;
}

.btn-confirm-delete {
  background-color: #f56c6c;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-confirm-delete:hover:not(:disabled) {
  background-color: #f78989;
}

.btn-confirm-delete:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ========== 响应式处理 ========== */

/* 中等屏幕（平板） */
@media (max-width: 1024px) {
  .user-table th,
  .user-table td {
    padding: 10px 12px;
  }
  
  .openid-cell {
    max-width: 150px;
  }
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.user-detail-table {
  min-width: 500px; /* 设置最小宽度，超出时滚动 */
}

/* 小屏幕（手机横屏/小平板） */
@media (max-width: 768px) {
  .user-list {
    padding: 12px;
  }

  h2 {
    font-size: 20px;
  }

  
  /* 表格转换为卡片样式 */
  .user-table thead {
    display: none;
  }
  
  .user-table tbody tr {
    display: block;
    margin-bottom: 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    background: white;
  }
  
  .user-table tbody tr:hover {
    transform: none;
  }
  
  .user-table td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
    gap: 12px;
  }
  
  .user-table td:last-child {
    border-bottom: none;
  }
  
  /* 添加伪元素作为标签 */
  .user-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #667eea;
    min-width: 80px;
    font-size: 13px;
  }
  
  .openid-cell {
    max-width: none;
    white-space: normal;
    word-break: break-all;
  }
  
  .detail-btn {
    width: 100%;
    padding: 8px;
  }
  
  .delete-modal {
    width: 95%;
  }
  
.modal {
  width: 90%;
  max-height: 96vh;
  margin-top: 20px;
}

}

/* 超小屏幕（手机竖屏） */
@media (max-width: 480px) {
  .user-list {
    padding: 10px;
  }
  
  .user-table td {
    padding: 8px 12px;
    font-size: 13px;
    flex-wrap: wrap;
  }
  
  .user-table td::before {
    min-width: 70px;
    font-size: 12px;
  }
  
  .pagination {
    gap: 10px;
  }
  
  .pagination button {
    padding: 6px 12px;
    font-size: 12px;
  }
  
  .pagination span {
    font-size: 12px;
  }
  
  .close-btn, .delete-user-btn {
    padding: 6px 15px;
    font-size: 12px;
  }
}

/* 保持弹框在小屏幕下的响应式 */
@media (max-width: 850px) {
  .modal {
    width: 95%;
    padding: 15px;
  }
  
  .modal table {
    width: 100%;
  }
}
</style>